import {
  CAPABILITY_VERIFICATION_ELIGIBLE_STATUSES,
  CAPABILITY_VERIFICATION_STATUS,
} from "../../constants/diagnosticCapabilities";
import {
  isEmergencyDepartment,
  isUrgentCare,
} from "../../constants/facilityTypes";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

function timestampToMs(tsLike) {
  if (!tsLike) return null;
  if (typeof tsLike === "number" && Number.isFinite(tsLike)) return tsLike;
  if (typeof tsLike?.toMillis === "function") return tsLike.toMillis();
  if (
    typeof tsLike === "object" &&
    Number.isFinite(tsLike.seconds) &&
    Number.isFinite(tsLike.nanoseconds)
  ) {
    return tsLike.seconds * 1000 + Math.floor(tsLike.nanoseconds / 1e6);
  }
  return null;
}

function daysUntilDeadline(deadlineMs, nowMs) {
  if (!Number.isFinite(deadlineMs)) return null;
  const deadline = new Date(deadlineMs);
  const now = new Date(nowMs);
  const deadlineDay = Date.UTC(
    deadline.getUTCFullYear(),
    deadline.getUTCMonth(),
    deadline.getUTCDate()
  );
  const nowDay = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Math.round((deadlineDay - nowDay) / MS_PER_DAY);
}

export function getCapabilityVerificationStatus(locationDoc, nowMs = Date.now()) {
  const verification = locationDoc?.capabilityVerification || {};
  const explicitStatus = verification?.status;
  if (typeof explicitStatus === "string" && explicitStatus.trim()) {
    return explicitStatus;
  }
  const deadlineMs = timestampToMs(verification?.nextDeadlineAt);
  if (!Number.isFinite(deadlineMs)) {
    return CAPABILITY_VERIFICATION_STATUS.UNVERIFIED;
  }
  const remainingDays = daysUntilDeadline(deadlineMs, nowMs);
  if (remainingDays == null) return CAPABILITY_VERIFICATION_STATUS.UNVERIFIED;
  if (remainingDays < 0) return CAPABILITY_VERIFICATION_STATUS.OVERDUE;
  if (remainingDays <= 7) return CAPABILITY_VERIFICATION_STATUS.DUE_SOON;
  return CAPABILITY_VERIFICATION_STATUS.VERIFIED;
}

export function isLocationCapabilityRankEligible(locationDoc, nowMs = Date.now()) {
  if (isEmergencyDepartment(locationDoc)) {
    return true;
  }
  if (isUrgentCare(locationDoc)) {
    return true;
  }
  const status = getCapabilityVerificationStatus(locationDoc, nowMs);
  return CAPABILITY_VERIFICATION_ELIGIBLE_STATUSES.includes(status);
}

